import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { Dropdown, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logoIcon from '../../../assets/images/logo-icon.png';
import logoVTS from '../../../assets/images/logo-vts.png';
import logo from '../../../assets/images/logo.png';
import avt from '../../../assets/images/user/0.jpg';
import { requestRefreshToken } from '../../../pages/AuthSignIn/AuthSignInSlice';
import { getDataUser } from '../../../pages/Profile/ProfileSlice';
import MultiLanguage from '../../Languages/MultiLanguage';
import Navbar from './Navbar';

export const changeLanguage = (i18n, language) => {
  localStorage.setItem('cft-language', language);
  i18n.changeLanguage(language);
};

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pathname = window.location.pathname;

  const token = localStorage.getItem('token');
  const refreshToken = Cookies.get('refreshToken');

  const [mobToggle, setMobToggle] = useState(false);
  const [isMobOpen, setMobOpen] = useState(false);
  const [size, setSize] = useState(window.innerWidth);

  const dataUser = useSelector((state) => state.profile.profile);
  const statusLogin = useSelector((state) => state.profile.status);
  const statusDashboard = useSelector((state) => state.dashboard.status);

  function deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  const parseJwt = (token) => {
    const decode = JSON.parse(atob(token.split('.')[1]));
    if (decode.exp * 1000 < new Date().getTime()) {
      dispatch(requestRefreshToken({ refreshToken }));
    }
  };

  useEffect(() => {
    if (token)
      parseJwt(token);
    if (statusLogin === 'failed') deleteAllCookies();
  }, [pathname, statusLogin, statusDashboard]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    deleteAllCookies();
  };

  useEffect(() => {
    dispatch(getDataUser(token));
  }, [token, dispatch]);

  return (
    <>
      <Navbar
        mob={isMobOpen}
        onClickOutside={() => {
          setMobOpen(false);
        }}
      />
      <header className="navbar pcoded-header navbar-expand-lg navbar-light headerpos-fixed">
        <div className="m-header">
          <Link
            to="#!"
            className={!isMobOpen ? 'mobile-menu' : 'mobile-menu on'}
            id="mobile-collapse1"
            onClick={() => {
              setMobOpen(!isMobOpen);
            }}
          >
            <span></span>
          </Link>
          <Link to="/" className="b-brand">
            <img src={logo} alt="" className="logo images" />
            <img src={logoIcon} alt="" className="logo-thumb images" />
          </Link>
        </div>
        <Link id="mobile-header" to="#!">
          <i className="feather icon-more-horizontal"></i>
        </Link>
        <div className="collapse navbar-collapse">
          <Link
            to="#!"
            className="mob-toggler"
            onClick={() => {
              setMobToggle(!mobToggle);
            }}
          ></Link>
          <ListGroup
            key={1}
            className="navbar-nav mr-auto"
            style={
              size > 991
                ? null
                : !mobToggle
                  ? { display: 'block' }
                  : { display: 'none' }
            }
          >
            <ListGroup.Item
              id="logoImg"
              style={{ paddingBottom: '0', border: '0' }}
            >
              <img src={logoVTS} alt="" height="48" />
            </ListGroup.Item>
          </ListGroup>
          <div
            className="navbar-nav ml-auto"
            style={
              size > 991
                ? null
                : !mobToggle
                  ? { display: 'none' }
                  : { display: 'block', height: '55px' }
            }
          >
            <ListGroup
              horizontal
              className="justify-content-center"
              style={{ marginTop: '8px' }}
            >
              <ListGroup.Item id="listGroup">
                <MultiLanguage />
              </ListGroup.Item>
              <ListGroup.Item
                id="listGroup"
                style={{ width: '40%', marginRight: '60px' }}
              >
                <Dropdown
                  id="dataUser"
                  style={{
                    margin: '0 auto !important',
                    height: '100%',
                  }}
                >
                  <Dropdown.Toggle
                    variant="none"
                    className="border-0 p-0"
                    style={{ lineHeight: '100%', marginTop: '-5px' }}
                  >
                    <div
                      variant="none"
                      className="border-0 p-0 btn"
                      id="dropdown-basic"
                      style={{
                        pointerEvents: 'none',
                      }}
                    >
                      <span className="d-block text-left">
                        <span className="d-block text-left font-weight-bold">
                          {dataUser.firstName
                            ? dataUser.firstName
                            : dataUser.name}
                        </span>
                        {dataUser.authority === 'TENANT_ADMIN'
                          ? 'Tenant administrator'
                          : 'Customer'}
                      </span>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="profile-notification">
                    <div className="pro-head">
                      <img
                        src={avt}
                        style={{ borderRadius: '50%' }}
                        alt="userProfileImage"
                      />
                      {dataUser.firstName ? dataUser.firstName : dataUser.name}
                      <a
                        href="/"
                        className="dud-logout"
                        title="Logout"
                        onClick={handleLogout}
                      >
                        <i className="feather icon-log-out"></i>
                      </a>
                    </div>
                    <ListGroup className="pro-body">
                      <Link to="/profile">
                        <ListGroup.Item>
                          <i className="feather icon-user"></i> {t('account')}
                        </ListGroup.Item>
                      </Link>
                      <div
                        onClick={handleLogout}
                        style={{ border: '0!important' }}
                      >
                        <a
                          href="/"
                          className="dud-logout"
                          title="Logout"
                          onClick={handleLogout}
                        >
                          <ListGroup.Item>
                            <i className="feather icon-lock"></i> {t('exit')}
                          </ListGroup.Item>
                        </a>
                      </div>
                    </ListGroup>
                  </Dropdown.Menu>
                </Dropdown>
              </ListGroup.Item>
            </ListGroup>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
